import { IsotopicDistribution } from 'isotopic-distribution';
import { generateMFs } from 'mf-generator';
import { xyObjectSlotX } from 'ml-spectra-processing/xyObject';
/**
 * Calculate tic for specific molecular formula and ionizations
 *
 * The system will take all the peaks with an intensity over 5% (default value)
 * @param chromatogram - GC/MS chromatogram where make the peak picking
 * @param targetMF - mass for which to extract the spectrum
 * @param options
 * @returns Calculated mass for targetMass
 */
export async function calculateForMF(chromatogram, targetMF, options = {}) {
    const { threshold = 0.05, slotWidth = 1, ionizations = 'H+' } = options;
    if (typeof targetMF !== 'string') {
        throw new Error('targetMF must be defined and a string');
    }
    const mfInfos = await generateMFs([targetMF]);
    const mfs = mfInfos.map((info) => info.mf);
    const halfWidth = slotWidth / 2;
    const ms = chromatogram.getSeries2D('ms');
    let masses = [];
    for (const mf of mfs) {
        const isotopicDistribution = new IsotopicDistribution(mf, {
            ionizations,
        });
        // we add isotopicDistribution in all the parts
        isotopicDistribution.getDistribution();
        const parts = isotopicDistribution.getParts();
        // @ts-expect-error It seems that IsotopicDistributionPart is not correctly typed.
        masses = masses.concat(...parts.map((part) => part.isotopicDistribution));
    }
    masses.sort((a, b) => a.x - b.x);
    masses = xyObjectSlotX(masses, { slotWidth }).filter((mass) => mass.y > threshold);
    const massSpectra = ms.getData();
    const result = new Array(massSpectra.length).fill(0);
    for (const targetMass of masses) {
        for (let i = 0; i < massSpectra.length; i++) {
            const massSpectrum = massSpectra[i];
            for (let j = 0; j < massSpectrum[0].length; j++) {
                if (Math.abs(massSpectrum[0][j] - targetMass.x) <= halfWidth) {
                    result[i] += massSpectrum[1][j];
                }
            }
        }
    }
    return result;
}
//# sourceMappingURL=calculate_for_mf.js.map